/**
 * Returns true if the object has a given property, even if that property is falsy.
 */
export function objectHas(obj: object, propertyName: string): boolean {
  while (obj) {
    if (Object.getOwnPropertyDescriptor(obj, propertyName)) {
      return true;
    }

    obj = Object.getPrototypeOf(obj);
  }

  return false;
}